import styled from 'styled-components';

export const PudoWrapper = styled.div`
  margin-bottom: 2.4rem;

  @media (max-width: 650px) {
    margin-bottom: 1.2rem;
  }
`;
